// Local fallback theme tokens for the Provenance DAG.
//
// Worker W8 is expected to export a shared `adaptiveSamplingTheme` object from
// `../primitives`. Until that module lands, consumers here read from this
// fallback so the tab renders standalone. When W8's module exists, callers
// should import from `../primitives` instead; this file can then be deleted.

export const fallbackTheme = {
  background: '#0d1117',
  surface: '#161b22',
  surfaceRaised: '#1f2733',
  border: '#2d333b',
  borderStrong: '#444c56',
  text: '#e6edf3',
  textMuted: '#8b949e',
  accent: '#58a6ff',
  accentMuted: '#1f6feb',
  status: {
    queued:  '#6e7681',
    running: '#d29922',
    done:    '#3fb950',
    failed:  '#f85149',
  },
  manualBadge: '#d2a8ff',
  forkEdge: '#bc8cff',
  batchEdge: '#8b949e',
} as const;

export type ProvenanceTheme = typeof fallbackTheme;
